import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Brush,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import {
  labelFormatterBillions,
  labelFormatterMoneyAsFloat,
  labelFormatterMoneyAsInteger,
  labelFormatterPercentile,
} from '../../../../../shared/formatters/formatters';
import { updateRequestStatusMarketCycle } from '../../redux/marketCycle.actions';
import { ReleasesINCCChartData } from './types';

export const ReleasesINCC: React.FC = () => {
  const { requesStatusMarketCycle, chartsDataMarketCycle } = useSelector(
    (state: any) => state.marketCycleState
  );

  return (
    <ChartCard
      data={chartsDataMarketCycle['releasesINCC']}
      Chart={ReleasesINCCChart}
      cy={'ReleasesINCC'}
      id={'releasesINCC'}
      requestStatus={requesStatusMarketCycle['releasesINCC']}
    />
  );
};

const ReleasesINCCChart: React.FC<IChartProps<ReleasesINCCChartData[]>> = ({
  data,
  cy,
  id,
}) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [
    labelFormatterMoneyAsInteger,
    labelFormatterPercentile,
  ];
  const dispatch = useDispatch();
  const getKeyINCC = () => {
    try {
      switch (data[0].type) {
        case 'month':
          return 'incc_in_month';
        case 'quarter':
          return 'incc_in_quarter';
        case 'year':
          return 'incc_in_year';
        default:
          return '';
      }
    } catch (e) {
      dispatch(
        updateRequestStatusMarketCycle({
          name: 'releasesINCC',
          value: 'LOADED',
        })
      );
      return;
    }
  };
  return data ? (
    <ResponsiveContainer data-cy={`ReleasesINCC${cy}`}>
      <LineChart
        id={id}
        data={data}
        margin={{
          top: 30,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <XAxis
          dataKey="period"
          padding={{ left: 30, right: 30 }}
          domain={['auto', 'dataMax']}
        />
        <Legend iconType="circle" />
        <YAxis
          yAxisId="price"
          orientation="left"
          tickFormatter={labelFormatterMoneyAsInteger}
          label={{
            value: nls.charts.releasesINCC.price,
            position: 'top',
            offset: 15,
          }}
        ></YAxis>
        <YAxis
          yAxisId="percentile"
          orientation="right"
          tickFormatter={labelFormatterPercentile}
          label={{
            value: nls.charts.releasesINCC.INCC,
            position: 'top',
            offset: 15,
          }}
        ></YAxis>
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <Line
          yAxisId="price"
          type="monotone"
          isAnimationActive={false}
          name={nls.charts.releasesINCC.primaryMarketPrice}
          dataKey="valor_m2_unid"
          stroke="#BA96D9"
        ></Line>
        <Line
          yAxisId="percentile"
          type="monotone"
          isAnimationActive={false}
          name={nls.charts.releasesINCC.INCC}
          dataKey={getKeyINCC()}
          stroke="#3F205A"
        ></Line>
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  ) : (
    <></>
  );
};
